// In actions/error.actions.ts
import { createAction, props } from '@ngrx/store';

export const handleError = createAction(
  '[Error] Handle error',
  props<{ error: string, exception:object }>()
);